import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { global } from '@angular/core/src/util';
import { GlobalProvider } from '../global/global';


/*
  Generated class for the SalaProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SalaProvider {

 
  
  
  private api: string;
  
  //private api;
  // , public  rurasdirective : RutasDirective
  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello PaisProvider Provider');
    //this.api = rurasdirective.ruta;
  }

  // Devuelve todos el reunion de un congreso
  public all(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavecongreso": clavecongreso 
    };
    
  
    return this.http.post(this.api+"sala/lista.php", parametros, options).map(
      (response) => {
       
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public detalle_sala(clave): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "clavesala": clave
    };
    
  
    return this.http.post(this.api+"sala/detalle_sala.php", parametros, options).map(
      (response) => {
       
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  
  
  // Inserta en el reunion.  
  public insert(congresoactivo, evento): Observable<any> {
   

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // evento.fechainicio = evento.fecha +  ' ' + evento.hora;

    let parametros ={
      "token":this.global.token,
      "tabla":"salas",
      "parametros" :evento
    };

    console.log(parametros);
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

    // Inserta en el reunion.  
    public update(congresoactivo, evento): Observable<any> {
     
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      // evento.fechainicio = evento.fecha +  ' ' + evento.hora;
  
      let parametros ={
        "token":this.global.token,
        "tabla":"salas",
        "clave": evento.clave,
        "parametros" :evento
      };
  
     
      return this.http.post(this.api+"apigen/update.php", parametros, options).map(
        (response) => {
          var respuesta = response.json();
         
         return respuesta[0];
        }
      ).catch(this.handleError);
    }

  // Elimina un congreso
  public delete(nnreunion): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "salas",
      "clave": nnreunion,
    };

  
    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }



    

  // Rutina de errores
  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }


}



// WEBPACK FOOTER //
// ./src/providers/sala/sala.ts